import axios from 'axios'
import { cleanBlankValue, openNewTabBlobFile } from 'utils/helper'

export const getFinancePurchaseOrders = (params) => {
  return axios.get('/finance/purchaseOrders', { params })
}

export const getTotalFinancePurchaseOrders = (params) => {
  return axios.get('/finance/purchaseOrders/totals', { params })
}

export const addFinancePurchaseOrder = (data) => {
  return axios.post('/finance/purchaseOrders', data)
}

export const editFinancePurchaseOrder = (data) => {
  return axios.put(`/finance/purchaseOrders/${data.id}`, data)
}

export const deleteOnAddFinancePurchaseOrderAttachment = (url) => {
  return axios.delete('/finance/purchaseOrders/attachments', { data: { url } })
}

export const deleteOnEditFinancePurchaseOrderAttachment = (id, url) => {
  return axios.delete(`/finance/purchaseOrders/${id}/attachments`, { data: { url } })
}

export const getFinancePurchaseOrder = (id, params) => {
  return axios.get(`/finance/purchaseOrders/${id}`, { params })
}

export const getFinancePurchaseOrderLog = ({ id, params } = {}) => {
  return axios.get(`/finance/purchaseOrders/${id}/logs`, { params })
}

export const changeFinancePurchaseOrderStatus = (id, data) => {
  return axios.patch(`/finance/purchaseOrders/${id}/status`, data)
}

export const deleteFinancePurchaseOrder = (id) => {
  return axios.delete(`/finance/purchaseOrders/${id}`)
}

export const uploadImportFinancePurchaseOrder = (data) => {
  return axios.postForm('/finance/purchaseOrders/uploadImport', data)
}

export const executeImportFinancePurchaseOrder = (data) => {
  return axios.post('/finance/purchaseOrders/executeImport', data)
}

export const getFinancePurchaseOrderJournal = (id) => {
  return axios.get(`/finance/transactions/${id}/journals`)
}

export const createPdfFinancePurchaseOrder = (id) => {
  return axios
    .get(`/finance/purchaseOrders/${id}/print`, { responseType: 'blob' })
    .then((response) => {
      openNewTabBlobFile(response)

      return Promise.resolve(true)
    })
    .catch((error) => {
      return Promise.reject(error)
    })
}

export const getFinancePurchaseOrderPublicUrl = (id) => {
  return axios.get(`/finance/purchaseOrders/${id}/publicUrl`)
}

export const exportFinancePurchaseOrder = (params) => {
  const URL =
    params.status_id === 'recurring' ? 'purchaseOrders/recurring/export' : 'purchaseOrders/export'
  if (params.status_id === 'recurring') {
    delete params.status_id
  }
  const query = cleanBlankValue(params)
  return axios.get(`/finance/${URL}`, { responseType: 'arraybuffer', params: query })
}

export const getFinancePurchaseOrderWaTemplate = (id) => {
  return axios.get(`/finance/purchaseOrders/${id}/whatsapp`)
}

export const getFinancePurchaseOrderInputWhatsappTemplate = (id) => {
  return axios.get(`/finance/purchaseOrders/${id}/inputWhatsapp`)
}

export const sendFinancePurchaseOrderWhatsapp = (payload) => {
  const { id, ...body } = payload
  return axios.post(`/finance/purchaseOrders/${id}/whatsapp`, body)
}

export const getFinancePurchaseOrderEmailTemplate = (id) => {
  return axios.get(`/finance/purchaseOrders/${id}/email`)
}

export const sendFinancePurchaseOrderEmail = (id, data) => {
  return axios.post(`/finance/purchaseOrders/${id}/email`, data)
}

export const addRecurringPurchaseOrder = (data) => {
  return axios.post('/finance/purchaseOrders/recurring', data)
}

export const editRecurringPurchaseOrder = (data) => {
  return axios.put(`/finance/purchaseOrders/recurring/${data.id}`, data)
}

export const getRecurringPurchaseOrder = (id) => {
  return axios.get(`/finance/purchaseOrders/recurring/${id}`)
}

export const deleteRecurringPurchaseOrder = (id) => {
  return axios.delete(`/finance/purchaseOrders/recurring/${id}`)
}

export const getRecurringPurchaseOrders = (params) => {
  return axios.get('/finance/purchaseOrders/recurring', { params })
}

export const getFinancePurchaseOrderSmsTemplate = (id) => {
  return axios.get(`/finance/purchaseOrders/${id}/sms`)
}

export const sendFinancePurchaseOrderSms = (id, data) => {
  return axios.post(`/finance/purchaseOrders/${id}/sms`, data)
}

export const inputMassDeleteFinancePurchaseOrder = (data) => {
  return axios.post('/finance/purchaseOrders/inputMassDelete', data)
}

export const executeMassDeleteFinancePurchaseOrder = (data) => {
  return axios.delete('/finance/purchaseOrders/executeMassDelete', { data })
}

export const inputMassSendEmailFinancePurchaseOrder = (data) => {
  return axios.post('/finance/purchaseOrders/inputMassEmail', data)
}

export const executeMassSendEmailFinancePurchaseOrder = (data) => {
  return axios.post('/finance/purchaseOrders/executeMassEmail', data)
}

export const inputMassSendWhatsappFinancePurchaseOrder = (data) => {
  return axios.post('/finance/purchaseOrders/inputMassWhatsapp', data)
}

export const executeMassSendWhatsappFinancePurchaseOrder = (data) => {
  return axios.post('/finance/purchaseOrders/executeMassWhatsapp', data)
}

export const getMassDownloadFinancePurchaseOrder = (params) => {
  return axios.get('/finance/purchaseOrders/massDownload', { params })
}

export const getMinTransDateFinancePurchaseOrder = (data) => {
  return axios.post('/finance/purchaseOrders/mass/minDate', data)
}

export const inputMassCreateFinancePurchaseOrder = (data) => {
  return axios.post('/finance/purchaseOrders/inputMassPurchaseOrder', data)
}

export const executeMassCreateFinancePurchaseOrder = (data) => {
  return axios.post('/finance/purchaseOrders/executeMassPurchaseOrder', data)
}

export const approveFinancePurchaseOrder = ({ id }) => {
  return axios.post(`/finance/purchaseOrders/${id}/approve`)
}

export const rejectFinancePurchaseOrder = ({ id, body }) => {
  return axios.post(`/finance/purchaseOrders/${id}/reject`, body)
}

export const revertApprovalFinancePurchaseOrder = ({ id }) => {
  return axios.post(`/finance/purchaseOrders/${id}/revert`)
}

export const closeFinancePurchaseOrder = ({ id, body }) => {
  return axios.post(`/finance/purchaseOrders/${id}/close`, body)
}

export const uncloseFinancePurchaseOrder = ({ id }) => {
  return axios.post(`/finance/purchaseOrders/${id}/unclose`)
}

export const editOnCompletePurchaseOrder = (data) => {
  return axios.patch(`/finance/purchaseOrders/${data.id}`, data)
}

/**
 * Draf baris Pesanan Pembelian dari Permintaan Pembelian terpilih.
 * Param: requestIds (dipisah koma, maks 100). Respons: items[] (dengan
 * purchase_request_item_id + product ter-embed) + skipped[]. Angka dihitung BE.
 */
export const getDraftPurchaseOrderFromRequest = (params) => {
  return axios.get('/finance/purchaseOrders/draftFromPurchaseRequest', { params })
}
